import React, { PureComponent } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import { Redirect, Route, Switch } from 'react-router-dom';
import Balaclava from 'cityads-v3/components/Balaclava/Balaclava';

// import AboutUs from './AboutUs';
import Contacts from './Contacts';
import Vacancy from './Vacancy';
import Policy from './Policy';
import NotFound from '../misc/NotFound';

import { ALLOWED_PATHS as STARTWORK_PATHS } from 'cityads-v3/components/Buttons/StartWorkButton';
export const ALLOWED_PATHS = [
  ...STARTWORK_PATHS,
  'auth',
  'lost'
];

@connect(
  state => ({
    language: state.language.language,
  })
)
@withTranslation(['About'], { i18n, wait: !!window })
export default class About extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    language: PropTypes.string,
    t: PropTypes.func
  }

  render() {
    const { t, language } = this.props;

    return (
      <>
        <Balaclava
          menuShow = {true}
          menu     = {[
            /*{
              id: 'about',
              title: t('About:tabAboutCompany'),
              route: '/main/about'
            },*/
            {
              id: 'contacts',
              title: t('About:tabContacts'),
              route: '/main/about/contacts'
            },
            {
              id: 'vacancy',
              title: t('About:tabVacancy'),
              route: '/main/about/vacancy'
            },
            ...(language === 'ru' ? [{
              id: 'policy',
              title: t('About:tabPolicy'),
              route: '/main/about/policy'
            }] : [])
          ]}
        />

        <Switch>
          <Route strict exact path={'/main/about/contacts/:sub(' + ALLOWED_PATHS.join('|') + ')?'} component={Contacts} />
          <Route strict exact path={'/main/about/policy/:sub(' + ALLOWED_PATHS.join('|') + ')?'} component={Policy} />
          <Route strict exact path={'/main/about/vacancy/:sub(' + ALLOWED_PATHS.join('|') + ')?'} component={Vacancy} />
          <Route strict exact path={'/main/about/:sub(' + ALLOWED_PATHS.join('|') + ')?'}><Redirect to="/main/about/contacts" /></Route>
          <Route component={NotFound}/>
        </Switch>
      </>
    );
  }
};
